import request from '@/utils/request';

export function getOrderList(values) {
  return request('/ec/order/queryOrderPage', {
    method: 'POST',
    data: values,
  });
}

export function getOrderSummary(values) {
  return request('/ec/order/queryOrderPageSummary', {
    method: 'POST',
    data: values,
  });
}
